import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 10px solid var(--dark-blue);
  min-height: 100%;
  > header {
    width: 100%;
  }
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 85px);
  position: relative;
  top: -85px;
`
const BoxInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 13%;
  width: 500px;
  > button {
    width: 155px;
    margin-top: 20px;
  }
`

const Title = styled.h1`
  color: var(--orange);
  text-align: center;
`

const Message = styled.p`
  color: var(--dark-blue);
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 15px;
`

export { Container, Title, Message, BoxInformation, Main }
